import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export class BaseStore extends Vue {
}
